import React from 'react';
export function HeroSection() {
  return <section className="py-8 text-center" data-id="element-28">
      <div className="bg-red-600 text-white py-2 px-4 inline-block rounded mb-6" data-id="element-29">
        <span className="font-bold" data-id="element-30">SPECIAL REPORT</span>
      </div>
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-31">
        Tired of Limping Through Life? This 58-Year-Old Grandmother's 'Weird'
        10-Minute Morning Ritual Eliminates Knee Pain Without Pills or Surgery
      </h1>
      <div className="w-full max-w-md mx-auto mb-8" data-id="element-32">
        <img src="https://images.unsplash.com/photo-1522849696084-818b96bd7568?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Senior woman enjoying active lifestyle" className="w-full h-auto rounded-lg shadow-lg" data-id="element-33" />
      </div>
    </section>;
}